import Vue from "vue";

export default Vue.extend({
  template: `
      <span>
        {{ formattedDate }}
      </span>
    `,
  data: function() {
    return {};
  },
  beforeCreate() {},
  beforeMount() {},
  mounted() {},
  computed: {
    formattedDate() {
      if (this.params.value) {
        let date = new Date(this.params.value);
        const offsetMonth = date.getMonth() + 1;
        const month = offsetMonth.toString().padStart(2, "0");
        const day = date
          .getDate()
          .toString()
          .padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      }
      return this.params.value;
    }
  },
  methods: {}
});
